import { AbstractReport } from '../abstract-report.model';
import { AccessorsMutatorsDecorator } from '../../../../helpers/model';

export class AverageDailyRate extends AbstractReport {

}

AccessorsMutatorsDecorator(
    'start',
    'end',
    'adr',
    'rooms_booked',
    'total_revenue',
    'adr_compare',
    'rooms_booked_compare',
    'total_revenue_compare',
    'change',
    'adr_pace',
)(AverageDailyRate);



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/production/average-daily-rate.model.js